/**
 * @generated SignedSource<<ca117beec687f0552ef7c8eba7328401>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RoadmapItem_collection$data = {
  readonly collectionId: AGG$Long;
  readonly emoji: string | null;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"ActionButtonsRoadmap_collection">;
  readonly " $fragmentType": "RoadmapItem_collection";
};
export type RoadmapItem_collection$key = {
  readonly " $data"?: RoadmapItem_collection$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoadmapItem_collection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "RoadmapItem_collection",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "title"
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "collectionId"
      },
      "action": "THROW"
    },
    {
      "kind": "ScalarField",
      "name": "emoji"
    },
    {
      "kind": "FragmentSpread",
      "name": "ActionButtonsRoadmap_collection"
    }
  ],
  "type": "JiraProductDiscoveryCollection"
};

(node as any).hash = "e248e39f34f1992fe9c03519e1a155a5";

export default node;
